<template>
    <div class="popup">
        <!--BEGIN HEADER-->
        <div class="popup__header">
            <div class="popup__name">{{features.name}}</div>
            <div class="popup__address">
                {{features.address}}
            </div>
            <div class="popup__tel">
                <svg class="popup__svg" width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.2195 9.49142L10.3621 7.6338C9.9921 7.26533 9.37944 7.27652 8.99659 7.65951L8.06082 8.59508C8.0017 8.56249 7.9405 8.52846 7.87616 8.49235C7.28523 8.16492 6.47644 7.71614 5.62536 6.86444C4.77176 6.01094 4.32257 5.20091 3.99414 4.6096C3.95948 4.54695 3.92627 4.48655 3.89348 4.42919L4.52152 3.80209L4.83029 3.49294C5.21373 3.1094 5.2243 2.4969 4.8552 2.12736L2.99779 0.26953C2.62869 -0.0994993 2.01575 -0.0883041 1.63232 0.295237L1.10883 0.821726L1.12314 0.835927C0.947607 1.0599 0.800928 1.31822 0.691775 1.59679C0.591155 1.86195 0.52851 2.11499 0.499866 2.36854C0.254606 4.40179 1.18374 6.26003 3.70531 8.78163C7.19087 12.267 9.99977 12.0037 10.121 11.9908C10.3849 11.9593 10.6378 11.8962 10.8948 11.7964C11.171 11.6885 11.4291 11.542 11.653 11.3669L11.6644 11.377L12.1947 10.8577C12.5774 10.4743 12.5884 9.86156 12.2195 9.49142Z" fill="#01254E"/>
                </svg>
                {{features.phone_number}}
            </div>
            <a :href="popupLink(features.web_site)" target="_blank" class="popup__link">
                <svg class="popup__svg" width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.70036 12.0002V9.42578C5.05565 9.45036 4.41714 9.54127 3.80957 9.69196C3.90741 9.92839 4.01449 10.1548 4.13045 10.3686C4.59323 11.2214 5.16837 11.8109 5.70036 12.0002Z" fill="#01254E"/>
                    <path d="M7.97958 10.3686C8.09554 10.1549 8.20262 9.92839 8.30046 9.69196C7.69289 9.54127 7.05438 9.45036 6.40967 9.42578V12.0002C6.94166 11.8109 7.5168 11.2214 7.97958 10.3686Z" fill="#01254E"/>
                    <path d="M5.70012 8.71586V6.35498H3.11279C3.14513 7.27668 3.30238 8.19302 3.5657 9.0226C4.25115 8.84678 4.97291 8.74173 5.70012 8.71586Z" fill="#01254E"/>
                    <path d="M5.70012 5.64555V3.28467C4.97291 3.25881 4.25115 3.15376 3.5657 2.97803C3.30238 3.80761 3.14513 4.72386 3.11279 5.64555H5.70012Z" fill="#01254E"/>
                    <path d="M8.98705 2.10853C9.41861 1.96301 9.82772 1.7859 10.2039 1.57996C9.54334 0.959547 8.74425 0.484839 7.8584 0.208496C8.12375 0.508306 8.37477 0.871959 8.60354 1.29354C8.74406 1.55233 8.87193 1.82489 8.98705 2.10853Z" fill="#01254E"/>
                    <path d="M4.13045 1.63154C4.01449 1.84534 3.90741 2.07179 3.80957 2.30822C4.41714 2.45891 5.05565 2.54982 5.70036 2.5744V0C5.16837 0.18931 4.59323 0.778768 4.13045 1.63154Z" fill="#01254E"/>
                    <path d="M6.40967 6.35498V8.71586C7.13697 8.74182 7.85864 8.84678 8.5441 9.0226C8.80741 8.19302 8.96466 7.27668 8.99709 6.35498H6.40967Z" fill="#01254E"/>
                    <path d="M6.40967 3.28467V5.64555H8.997C8.96466 4.72386 8.80741 3.80761 8.5441 2.97803C7.85864 3.15376 7.13697 3.25881 6.40967 3.28467Z" fill="#01254E"/>
                    <path d="M2.88271 9.22549C2.59907 8.33244 2.43424 7.35503 2.40255 6.35498H0C0.0777012 7.69558 0.592691 8.9206 1.40417 9.88942C1.85615 9.62712 2.35441 9.40445 2.88271 9.22549Z" fill="#01254E"/>
                    <path d="M8.98705 9.89209C8.87184 10.1757 8.74397 10.4483 8.60354 10.7072C8.37477 11.1287 8.12375 11.4923 7.8584 11.7921C8.74425 11.5158 9.54334 11.0411 10.204 10.4207C9.82772 10.2147 9.41861 10.0376 8.98705 9.89209Z" fill="#01254E"/>
                    <path d="M3.12265 9.89209C2.69109 10.0376 2.28198 10.2147 1.90576 10.4207C2.56636 11.0412 3.36546 11.5158 4.2513 11.7922C3.98605 11.4923 3.73502 11.1287 3.50617 10.7072C3.36564 10.4483 3.23777 10.1757 3.12265 9.89209Z" fill="#01254E"/>
                    <path d="M9.22754 2.77467C9.51118 3.66773 9.67601 4.64514 9.7077 5.64518H12.1102C12.0325 4.30458 11.5176 3.07966 10.7061 2.11084C10.2541 2.37314 9.75583 2.59571 9.22754 2.77467Z" fill="#01254E"/>
                    <path d="M9.22754 9.22549C9.75583 9.40445 10.2541 9.62703 10.7061 9.88932C11.5176 8.92051 12.0325 7.69549 12.1102 6.35498H9.7077C9.67601 7.35503 9.51118 8.33244 9.22754 9.22549Z" fill="#01254E"/>
                    <path d="M6.40967 0V2.5744C7.05438 2.54982 7.69289 2.45891 8.30046 2.30831C8.20262 2.07179 8.09563 1.84534 7.97958 1.63154C7.5168 0.778768 6.94166 0.18931 6.40967 0Z" fill="#01254E"/>
                    <path d="M2.88271 2.77467C2.35441 2.59571 1.85615 2.37314 1.40417 2.11084C0.592599 3.07966 0.0777012 4.30468 0 5.64518H2.40255C2.43424 4.64514 2.59907 3.66773 2.88271 2.77467Z" fill="#01254E"/>
                    <path d="M3.12274 2.10853C3.23795 1.82489 3.36582 1.55233 3.50626 1.29354C3.73502 0.871867 3.98605 0.508306 4.2514 0.208496C3.36555 0.484839 2.56645 0.959547 1.90576 1.57996C2.28207 1.7859 2.69118 1.96301 3.12274 2.10853Z" fill="#01254E"/>
                </svg>
                <span>
                    {{features.web_site}}
                </span>
            </a>
        </div>
        <!--END HEADER-->
        <!--BEGIN BODY-->
        <div class="popup__body">
            <div class="service__item" v-for="service in services" :key="service.id">
                <div class="service__box" :style="`background-color: ${service.color_hex}`"></div>
                <div class="service__name">
                    {{service.name}}
                </div>
            </div>
        </div>
        <!--END BODY-->
        <!--BEGIN FOOTER-->
        <div class="popup__footer">
                <div class="popup__row">
                    <div class="popup__col">
                        {{$t("popupRadius", {km: features.protection_area_radius_km}) }}
                    </div>
                    <div class="popup__action">
                        <radiusSwitcher
                                :id="features.id"
                                :protection_area="features.protection_area_radius_enabled"
                        />
                        <!--<radiusControls :min="0" :max="20" :id="features.id" :value="Number(features.protection_area_radius_km)"></radiusControls>-->
                    </div>
                </div>
                <div class="popup__row">
                    <div class="popup__col">
                        {{$t("popupTimezone")}}
                    </div>
                    <div class="popup__action">
                        <drivingControls :id="features.id" :time="features.driving_time_zone_minutes"></drivingControls>
                    </div>
                </div>
                <div class="popup__row popup__row-bordered">
                    <div class="popup__col">
                        {{$t("popupData")}}
                    </div>
                    <div class="popup__action w-85">
                        <uploadFiles></uploadFiles>
                        <removeAddresses :id="features.id"></removeAddresses>
                    </div>
                </div>
                <div class="popup__row">
                    <div class="popup__col">
                        {{$t("popupReport")}}
                    </div>
                    <div class="popup__action w-85">
                        <pdfReport :isDisabled="isAvaibleAddress"></pdfReport>
                        <xlsxReport :isDisabled="isAvaibleAddress"></xlsxReport>
                    </div>
                </div>


        </div>
        <!--END FOOTER-->
    </div>
</template>

<script>
    import Vue from 'vue'
    import radiusSwitcher from './popupRadiusSwitcher.vue'
    import drivingControls from './popupDrivingControls.vue'
    import uploadFiles from './popupUploadFiles.vue'
    import removeAddresses from './popupRemoveAddresses.vue'
    import pdfReport from './popupPdfReport.vue'
    import xlsxReport from './popupXlsxReport.vue'

    export default Vue.extend({
        components: {
//            radiusControls,
            removeAddresses,
            drivingControls,
            uploadFiles,
            pdfReport,
            xlsxReport,
            radiusSwitcher
        },
        data() {
          return {
              services: []
          }
        },
        props: {
            features: {
                required: true,
                type: Object,
            },
        },
        methods: {
          popupLink(link) {
              return `https://${link}`
          }
        },
        computed: {
            getAddresses() {
              return this.$store.getters.getAddresses
            },
          isAvaibleAddress() {
              let serviceId = this.features.id;
              let addresses = this.getAddresses.features;
              let haveAddress = addresses.filter(location => location.properties.location_id === serviceId)
              return haveAddress.length ? false : true

            }
        },
        created() {
            this.services = JSON.parse(this.features.services)
        },
    })
</script>